var HTTP_SCHEME = /^https?:\/\//i;
var DEFAULT_SCHEME = "https://";
/**
 * Letters and digits allowed in a domain label: ASCII plus the Latin-1 and Latin Extended-A letters
 * (all Czech diacritics). Written as explicit ranges because the stripes build compiles for a target
 * without the regex `u` flag / Unicode property escapes.
 */
var LABEL_CHAR = "a-z0-9À-ÖØ-öø-ž";
var LETTER = "a-zÀ-ÖØ-öø-ž";
/**
 * An absolute http(s) URL with a domain host of at least two labels (letters incl. diacritics,
 * digits, inner hyphens) and a top-level domain of at least two letters, an optional port and an
 * optional path / query / fragment without whitespace.
 */
var WEB_URL = new RegExp("^https?://(?:[".concat(LABEL_CHAR, "](?:[").concat(LABEL_CHAR, "-]*[").concat(LABEL_CHAR, "])?\\.)+[").concat(LETTER, "]{2,}(?::\\d{1,5})?(?:[/?#]\\S*)?$"), "i");
/**
 * Normalizes a web address entered by a user: a value without a scheme (e.g. "www.nakladatel.cz"
 * or "nakladatel.cz") gets "https://" prepended, a value with an http(s) scheme is kept as is.
 *
 * @param value the raw value of a web contact
 * @return the normalized absolute URL, or null when the value is not a valid web address
 */
export var normalizeWebUrl = function (value) {
    var trimmed = value.trim();
    if (!trimmed)
        return null;
    var withScheme = HTTP_SCHEME.test(trimmed)
        ? trimmed
        : "".concat(DEFAULT_SCHEME).concat(trimmed);
    return WEB_URL.test(withScheme) ? withScheme : null;
};
